var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeubleBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.333,
    height: 38.899,
    viewBox: "0 0 35.333 38.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_408",
    x: 0,
    y: 0,
    width: 35.333,
    height: 38.899,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_409",
    x: 9.416,
    y: 6.199,
    width: 10.541,
    height: 14.041,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_410",
    x: 12.374,
    y: 6.199,
    width: 10.546,
    height: 14.045,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_411",
    x: 9.409,
    y: 15.944,
    width: 10.525,
    height: 14.025,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_412",
    x: 12.388,
    y: 15.948,
    width: 10.535,
    height: 14.01,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_413",
    x: 9.411,
    y: 9.454,
    width: 10.524,
    height: 14.024,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_414",
    x: 9.41,
    y: 12.698,
    width: 10.533,
    height: 14.021,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_415",
    x: 12.394,
    y: 12.703,
    width: 10.528,
    height: 14.023,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_416",
    x: 9.407,
    y: 19.195,
    width: 10.531,
    height: 14.017,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_417",
    x: 12.39,
    y: 19.197,
    width: 10.528,
    height: 14.014,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_418",
    x: 15.32,
    y: 6.219,
    width: 10.529,
    height: 14.024,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_419",
    x: 12.39,
    y: 9.464,
    width: 10.528,
    height: 14.016,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_420",
    x: 15.328,
    y: 9.46,
    width: 10.52,
    height: 14.022,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_421",
    x: 15.327,
    y: 12.704,
    width: 10.522,
    height: 14.02,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_422",
    x: 15.321,
    y: 15.952,
    width: 10.525,
    height: 14.012,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_423",
    x: 15.322,
    y: 19.197,
    width: 10.523,
    height: 14.012,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d9d4d4",
    floodOpacity: 0.69
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_320",
    "data-name": "Groupe 320",
    transform: "translate(198.222 -677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_408-2",
    "data-name": "Trac\\xE9 408",
    d: "M-167.389,701.852V703.4h-26.333v-1.552h.823V684.979h-.812v-1.548h6.611v-.3c0-.791.005-1.581,0-2.372a.346.346,0,0,1,.213-.359q2.69-1.436,5.371-2.888c.3-.161.587-.34.88-.51h.155a1.9,1.9,0,0,0,.2.143c1.954,1.054,3.905,2.115,5.868,3.151a.622.622,0,0,1,.394.668c-.029.729-.01,1.46-.008,2.19,0,.09.009.18.014.283h1.835l4.792.01v1.547h-.814v16.861Zm-8.2-.013c0-.077.009-.136.009-.195q0-10,0-20a.292.292,0,0,0-.177-.3q-2.315-1.237-4.623-2.489a.343.343,0,0,0-.374,0q-2.284,1.24-4.576,2.465a.364.364,0,0,0-.222.377q.008,9.937,0,19.875v.266h4.209v-2.716h1.549v2.718Zm3.733-7.611h-2.151v1.55h2.15v1.535h-2.156v4.528h4.219V685.009h-4.222v1.483h2.157v1.562h-2.154v1.534h2.152v1.556h-2.153v1.533h2.158Zm-17.378-3.094v-1.555h2.136c0-.4,0-.786,0-1.17,0-.36,0-.36-.359-.36h-1.781v-1.561h2.122V685h-4.188v16.837h4.188V697.3h-2.127v-1.536h2.128v-1.554h-2.119v-1.552h2.117v-1.527Z",
    transform: "translate(198.22 -677)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_409-2",
    "data-name": "Trac\\xE9 409",
    d: "M-11.111,797.222c.476,0,.936,0,1.4.007a.211.211,0,0,1,.138.153c.011.453.006.906.006,1.38h-1.54Z",
    transform: "translate(25.03 -791.02)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_410)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_410-2",
    "data-name": "Trac\\xE9 410",
    d: "M46.263,798.765c0-.48,0-.933.006-1.386a.212.212,0,0,1,.14-.151c.46-.012.92-.007,1.4-.007v1.544Z",
    transform: "translate(-29.39 -791.02)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_411-2",
    "data-name": "Trac\\xE9 411",
    d: "M-9.706,987.744h-1.525v-1.525h1.525Z",
    transform: "translate(25.14 -970.28)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_412-2",
    "data-name": "Trac\\xE9 412",
    d: "M46.535,987.816v-1.51H48.07v1.51Z",
    transform: "translate(-29.65 -970.36)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_413-2",
    "data-name": "Trac\\xE9 413",
    d: "M-11.208,861.882v-1.524h1.524v1.524Z",
    transform: "translate(25.12 -850.9)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_414-2",
    "data-name": "Trac\\xE9 414",
    d: "M-9.686,923.275V924.8h-1.533v-1.521Z",
    transform: "translate(25.13 -910.58)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_415-2",
    "data-name": "Trac\\xE9 415",
    d: "M48.182,924.883H46.654V923.36h1.528Z",
    transform: "translate(-29.76 -910.66)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_416-2",
    "data-name": "Trac\\xE9 416",
    d: "M-11.271,1050.791v-1.517H-9.74v1.517Z",
    transform: "translate(25.18 -1030.08)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_417-2",
    "data-name": "Trac\\xE9 417",
    d: "M48.108,1050.839H46.58v-1.514h1.528Z",
    transform: "translate(-29.69 -1030.13)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_418-2",
    "data-name": "Trac\\xE9 418",
    d: "M104.923,797.6v1.524h-1.529V797.6Z",
    transform: "translate(-83.57 -791.39)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_419-2",
    "data-name": "Trac\\xE9 419",
    d: "M46.583,862.063v-1.516h1.528v1.516Z",
    transform: "translate(-29.69 -851.08)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_420)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_420-2",
    "data-name": "Trac\\xE9 420",
    d: "M105.082,862h-1.52v-1.522h1.52Z",
    transform: "translate(-83.73 -851.02)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_421-2",
    "data-name": "Trac\\xE9 421",
    d: "M105.063,924.9h-1.522v-1.52h1.522Z",
    transform: "translate(-83.71 -910.68)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_422-2",
    "data-name": "Trac\\xE9 422",
    d: "M103.431,987.9v-1.512h1.525V987.9Z",
    transform: "translate(-83.61 -970.43)",
    fill: "#4fb0db"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -198.22, 677)",
    filter: "url(#Trac\\xE9_423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_423-2",
    "data-name": "Trac\\xE9 423",
    d: "M104.969,1050.832h-1.523v-1.512h1.523Z",
    transform: "translate(-83.62 -1030.12)",
    fill: "#4fb0db"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeubleBlueIcon);
export default __webpack_public_path__ + "static/media/meuble-blue-icon.58cd2d2a5ae13da6cd5af335a9b3fa6c.svg";
export { ForwardRef as ReactComponent };